<template>
  <div class="span-element-container">
    <span :class="classObject">{{ mutatedValue ? mutatedValue : content }}</span>
  </div>
</template>

<script>
export default {
  name: 'SpanElement',
  props: {
    defaultValue: [String, Array],
    name: String,
    dataOptions: Array,
    className: String,
    content: String
  },
  data() {
    return {
      mutatedValue: this.defaultValue,
      mutatedDataOptions: this.dataOptions,
      classObject: { [this.className]: true }
    }
  }
}
</script>

<style scoped>
  .span-element-container {
    display: flex;
    text-align: left;
    margin: 20px 0;
  }
</style>
